module.exports = __webpack_public_path__ + "static/media/arrow_down_sp.418f0b73.svg";